"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ContextMenu_meta_1 = require("../ContextMenu.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var Image_1 = __importDefault(require("../../Image/Image"));

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(Image_1.default, ContextMenu_meta_1.CONTEXT_MENU_CATEGORY_KEY, ContextMenu_meta_1.CONTEXT_MENU_COMPONENT_KEY, ['icon']);